var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PEPHealthClient from '../client';
var kemtaiPathMap = {
    integrationKemtaiStaff: 'integrations/kemtai/v1/staff/',
    patients: 'integrations/kemtai/v1/patients/',
    patientDetails: 'integrations/kemtai/v1/patients/{{appUserId}}/',
};
var KemtaiClient = /** @class */ (function (_super) {
    __extends(KemtaiClient, _super);
    function KemtaiClient(jwt, options) {
        var _this = _super.call(this, jwt, options) || this;
        _this.jwt = jwt;
        _this.pathMap = Object.assign(_this.pathMap, kemtaiPathMap);
        return _this;
    }
    KemtaiClient.prototype.kemtaiStaffList = function (kemtaiAPIKey) {
        var queryParams = {};
        if (kemtaiAPIKey) {
            queryParams['kemtai_api_key'] = kemtaiAPIKey;
        }
        return this.apiRequest('integrationKemtaiStaff', 'Failed to list Kemtai staff', 'GET', queryParams, undefined);
    };
    KemtaiClient.prototype.getPatient = function (appUserId) {
        return this.apiRequest('patientDetails', 'Failed to get Kemtai Patient details', 'GET', undefined, undefined, { appUserId: appUserId });
    };
    KemtaiClient.prototype.createPatient = function (appUserId) {
        return this.apiRequest('patients', 'Failed to create Kemtai Patient', 'POST', undefined, { app_user_id: appUserId });
    };
    return KemtaiClient;
}(PEPHealthClient));
export default KemtaiClient;
//# sourceMappingURL=client.js.map